var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHelp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 8,
  stroke: "currentColor",
  strokeWidth: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9 12a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm0-7.875c1.852 0 3.375 1.27 3.375 2.875 0 .775-.197 1.403-.596 1.877-.388.462-.884.676-1.267.796-.191.06-.379.103-.519.137-.045.01-.083.022-.118.03v.66a.875.875 0 1 1-1.75 0v-1c0-.341.126-.652.362-.89.205-.205.447-.31.612-.368.169-.06.353-.103.49-.136.152-.036.278-.065.4-.103.24-.076.37-.157.45-.252.07-.083.186-.276.186-.751 0-.395-.477-1.125-1.625-1.125-1.148 0-1.625.73-1.625 1.125a.875.875 0 0 1-1.75 0c0-1.605 1.523-2.875 3.375-2.875Z"
})));
export default SvgIconHelp;